<template>
  <div class="bottom">
    <div class="section-right">
      <div class="file-actions">
        <template
          v-if="
            $store.getters.GET_CURRENT_DIRECTORY != 'Trash' &&
            $store.getters.GET_CURRENT_DIRECTORY !== 'Shared Files' &&
            $store.getters.GET_CURRENT_DIRECTORY !== 'Shared With Me'
          "
        >
          <div
            class="action share-file"
            @click="sharefile"
            v-if="$store.getters.FILE_ACTION"
          >
            <img
              src="@/assets/header-option-icons/share-icon.svg"
            />&nbsp;&nbsp;
            <span class="trash"> Share File </span>
          </div>
          <div
            class="action delete-file"
            @click="deletefile"
            v-if="$store.getters.FILE_ACTION == 1"
          >
            <img
              src="@/assets/header-option-icons/delete-icon.svg"
            />&nbsp;&nbsp;
            <span class="trash"> Delete File </span>
          </div>
          <div
            class="action delete-file"
            @click="deletefiles"
            v-if="$store.getters.FILE_ACTION > 1"
          >
            <img
              src="@/assets/header-option-icons/delete-icon.svg"
            />&nbsp;&nbsp;
            <span class="trash"> Delete </span>
          </div>
          <div
            class="action move-folder"
            @click="moveto"
            v-if="$store.getters.FILE_ACTION"
          >
            <img src="@/assets/header-option-icons/move-icon.svg" />&nbsp;&nbsp;
            <span class="folder-move"> Move to </span>
          </div>
          <div
            class="action copy-file"
            @click="copyto"
            v-if="$store.getters.FILE_ACTION"
          >
            <img src="@/assets/header-option-icons/copy-icon.svg" />&nbsp;&nbsp;
            <span class="vector-arrange-below"> Copy to </span>
          </div>
          <div
            class="action rename-file"
            @click="renamefile"
            v-if="$store.getters.FILE_ACTION == 1"
          >
            <img
              src="@/assets/header-option-icons/rename-icon.svg"
            />&nbsp;&nbsp;
            <span class="vector-arrange-below"> Rename </span>
          </div>
          <div
            class="action compress-file"
            @click="compressfile"
            v-if="$store.getters.FILE_ACTION"
          >
            <img
              src="@/assets/header-option-icons/compress-icon.svg"
            />&nbsp;&nbsp;
            <span class="vector-arrange-below"> Compress </span>
          </div>
          <div
            class="action favourite-file"
            @click="addtofavourite"
            v-if="$store.getters.FILE_ACTION"
          >
            <img
              src="@/assets/header-option-icons/favourite-icon.svg"
            />&nbsp;&nbsp;
            <span class="vector-arrange-below"> Add to favourite </span>
          </div>
          <div
            class="action add-comment-file"
            @click="addcomment"
            v-if="$store.getters.FILE_ACTION == 1"
          >
            <img src="@/assets/header-option-icons/chat-icon.svg" />&nbsp;&nbsp;
            <span class="vector-arrange-below"> Add Comment </span>
          </div>
        </template>
        <template v-if="$store.getters.GET_CURRENT_DIRECTORY == 'Trash'">
          <div
            class="action delete-file"
            @click="deletefile"
            v-if="$store.getters.FILE_ACTION == 1"
          >
            <img
              src="@/assets/header-option-icons/delete-icon.svg"
            />&nbsp;&nbsp;
            <span class="trash"> Delete File </span>
          </div>
          <div
            class="action delete-file"
            @click="deleteall"
            v-if="$store.getters.FILE_ACTION > 1"
          >
            <img src="@/assets/header-option-icons/delete-icon.svg" />&nbsp;&nbsp;
            <span class="trash"> Delete </span>
          </div>
          <div
            class="action delete-file"
            @click="restorefile"
            v-if="$store.getters.FILE_ACTION == 1"
          >
            <span class="trash">
              <svg style="width: 18px; height: 18px" viewBox="0 0 24 24">
                <path
                  d="M10.5,7A6.5,6.5 0 0,0 4,13.5A6.5,6.5 0 0,0 10.5,20H14V18H10.5C8,18 6,16 6,13.5C6,11 8,9 10.5,9H16.17L13.09,12.09L14.5,13.5L20,8L14.5,2.5L13.08,3.91L16.17,7H10.5M18,18H16V20H18V18Z"
                />
              </svg>
            </span>
            <span> Restore File </span>
          </div>
          <div
            class="action delete-file"
            @click="restore"
            v-if="$store.getters.FILE_ACTION > 1"
          >
            <span class="trash">
              <svg style="width: 18px; height: 18px" viewBox="0 0 24 24">
                <path
                  d="M10.5,7A6.5,6.5 0 0,0 4,13.5A6.5,6.5 0 0,0 10.5,20H14V18H10.5C8,18 6,16 6,13.5C6,11 8,9 10.5,9H16.17L13.09,12.09L14.5,13.5L20,8L14.5,2.5L13.08,3.91L16.17,7H10.5M18,18H16V20H18V18Z"
                />
              </svg>
            </span>
            <span>Restore</span>
          </div>
        </template>
        <template v-if="$store.getters.GET_CURRENT_DIRECTORY == 'Shared Files'">
          <div
            class="action delete-file"
            @click="deletefile"
            v-if="$store.getters.FILE_ACTION == 1"
          >
            <img src="@/assets/header-option-icons/chat-icon.svg" />&nbsp;&nbsp;
            <span class="trash"> Delete File </span>
          </div>
          <div
            class="action delete-file"
            @click="deleteall"
            v-if="$store.getters.FILE_ACTION > 1"
          >
            <img src="@/assets/header-option-icons/chat-icon.svg" />&nbsp;&nbsp;
            <span class="trash"> Delete </span>
          </div>
          <div
            class="action favourite-file"
            @click="addtofavourite"
            v-if="$store.getters.FILE_ACTION"
          >
            <img
              src="@/assets/header-option-icons/favourite-icon.svg"
            />&nbsp;&nbsp;
            <span class="vector-arrange-below"> Add to favourite </span>
          </div>
          <div
            class="action add-comment-file"
            @click="addcomment"
            v-if="$store.getters.FILE_ACTION == 1"
          >
            <img src="@/assets/header-option-icons/chat-icon.svg" />&nbsp;&nbsp;
            <span class="vector-arrange-below"> Add Comment </span>
          </div>
        </template>
        <template
          v-if="$store.getters.GET_CURRENT_DIRECTORY == 'Shared With Me'"
        >
          <div
            class="action favourite-file"
            @click="addtofavourite"
            v-if="$store.getters.FILE_ACTION"
          >
            <img
              src="@/assets/header-option-icons/favourite-icon.svg"
            />&nbsp;&nbsp;
            <span class="vector-arrange-below"> Add to favourite </span>
          </div>
          <div
            class="action add-comment-file"
            @click="addcomment"
            v-if="$store.getters.FILE_ACTION == 1"
          >
            <img src="@/assets/header-option-icons/chat-icon.svg" />&nbsp;&nbsp;
            <span class="vector-arrange-below"> Add Comment </span>
          </div>
        </template>
      </div>
      <div class="selected">
        <span>{{ $store.getters.FILE_ACTION }} selected</span>&nbsp;&nbsp;
        <img src="@/assets/option-close.svg" @click="close_header_option" />
      </div>
    </div>
  </div>
</template>
<style>
.bottom {
  height: 75px;
  background: #f2f7fc;
  display: flex;
}

.bottom .section-right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px;
  width: 100%;
}

.selected {
  color: #3f96d1;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.selected img {
  cursor: pointer;
}
</style>
<script>
import ClickOutside from "vue-click-outside";
import { mapMutations } from "vuex";
import { directive as onClickaway } from "vue-clickaway";
import moment from "moment";
// import Onboard from '@/components/Onboard'
import cookies from "@/services/cookies";

export default {
  data() {
    return {
      id: localStorage.getItem("id"),
      file_actions: false,
      create_dropdown: false,
      sort_order: false,
      view_options: false,
      listdown: false,
      settings_dropdown: false,
      notification_dropdown: false,
      type_term: "",
      advance: false,
      doctype: false,
      file_owner: false,
      select_date: false,
      start_date: "",
      end_date: "",
      filetype: "Select file type",
      fileowner: "Owned by me",
      filedate: "Select date file was modified",
      filelocation: "My Space",
      file_location: false,
      filename: "",
      post: false,
      show_min: false,
      lang: {
        type: "en",
      },
      env: process.env.NODE_ENV === "development" ? "local" : "prod",
      host: location.hostname,
      protocol: location.protocol,
      userdropdown: false,
      sub_dropdown: true,
      TASKS: process.env.VUE_APP_TASKS,
      TEAMS: process.env.VUE_APP_TEAMS,
      MESSAGE: process.env.VUE_APP_MESSAGE,
      MEETING: process.env.VUE_APP_MEETING,
      CALENDAR: process.env.VUE_APP_CALENDAR,
      PROJECTS: process.env.VUE_APP_PROJECTS,
      DRIVE: process.env.VUE_APP_DRIVE,
      DASHBOARD: process.env.VUE_APP_DASHBOARD,
      EXPLORE: process.env.VUE_APP_EXPLORE,
    };
  },
  computed: {
    showNewButton() {
      return this.$store.getters.showNewButton;
    },
  },
  methods: {
    close_header_option() {
      this.EMPTY_FILE_ACTION();

      let dir_children = this.$store.getters.DIRECTORY_CHILDREN.map((dir) => {
        dir.is_checked = false;
        return dir;
      });

      this.SET_DIRECTORY_CHILDREN(dir_children);
    },
    copy_invite_link() {
      let link = document.querySelector("#referral_link").value;
      let a = document.createElement("input");

      a.setAttribute("value", link);
      a.setAttribute("id", "referallink");
      a.click();
      a.style.position = "absolute";
      a.style.left = "-9999px";
      document.body.appendChild(a);
      let l = document.getElementById("referallink");
      l.select();
      document.execCommand("copy");
      document.body.removeChild(a);

      let that = this;

      that.$toast.open({
        message:
          '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg> Referral link copied to clipboard',
        type: "default",
        position: "bottom-right",
      });
    },
    hide_userdropdown() {
      this.userdropdown = false;
    },
    getName(name) {
      return name[0];
    },
    invite() {
      this.$parent.invite();
    },
    drop_min() {
      if (!this.show_min) {
        this.show_min = true;
      } else {
        this.show_min = false;
      }
    },
    show_subdown() {
      this.sub_dropdown = !this.sub_dropdown;
    },
    logout() {
      this.$parent.logout();
    },
    format_date(date) {
      return moment(date).format("DD MMMM, YYYY");
    },
    ago(time) {
      return moment(time).fromNow();
    },
    ...mapMutations([
      "SET_SORT_TYPE",
      "SET_SORT_ORDER",
      "SET_VIEW_TYPE",
      "SORT_DIRECTORY_CHILDREN",
      "TOGGLE_CHAT",
      "TOGGLE_NOTE",
      "TOGGLE_NOTIFICATION",
      "UPDATE_SLIDEIN",
      "UPDATE_SLIDEOUT",
      "UPDATE_BODY_MENU",
      "UPDATE_MENU",
      "SET_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "SORT_DIRECTORY_CHILDREN",
      "UPDATE_NOTIFICATION_COUNT",
      "TOGGLE_EMBED",
      "SET_PATH",
      "EMPTY_FILE_ACTION",
    ]),
    download() {
      let a = document.createElement("a");
      a.setAttribute("download", true);
      let href = "https://fexspace.com/downloads/Fexspace-client-Setup.exe";
      a.setAttribute("href", href);
      a.hidden = true;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    logincall() {
      this.$parent.logincall();
    },
    user_dropdown() {
      this.userdropdown = !this.userdropdown;
      this.sub_dropdown = false;
    },
    handleScroll(evt) {
      // console.log(evt.target.clientHeight)
      // console.log(evt.target.scrollTop)
      // console.log(evt.target.scrollHeight)

      if (
        evt.target.clientHeight + evt.target.scrollTop >=
        evt.target.scrollHeight
      ) {
        let data = {
          token: cookies.getCookie("token"),
          cur_page: this.$store.getters.NOTIFICATION.length,
        };
        this.$socket.emit("load-notification", data, function (data) {});
      }
    },
    typeterm(evt) {
      this.listdown = false;

      if (evt.keyCode === 13 || evt.which === 13) {
        let term = evt.target.value;

        this.searchfile();
        let data = {
          token: cookies.getCookie("token"),
          term: term,
          method: "text",
        };

        let that = this;

        this.$socket.emit("findfile", data, function (data) {
          if (data.data === true) {
            that.closesearch();
            that.SET_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
            that.SORT_DIRECTORY_CHILDREN();
            that.SET_PATH(data.dir_path);
          }

          if (data.data === false) {
            that.closesearch();
            that.logincall();
            that.$router.push('/login')
          }
        });
      }
    },
    select_fileowner(evt) {
      if (evt.target.nodeName === "LI") {
        this.fileowner = evt.target.getAttribute("data-text");
        this.file_owner = false;
      }
    },
    select_filetype(evt) {
      if (evt.target.nodeName === "LI") {
        this.filetype = evt.target.getAttribute("data-text");
        this.doctype = false;
      }
    },
    selectdate(evt) {
      if (evt.target.nodeName === "LI") {
        this.filedate = evt.target.getAttribute("data-text");
        this.select_date = false;

        if (this.filedate !== "Custom Date") {
          this.start_date = "";
          this.end_date = "";
        }
      }
    },
    selectfilelocation() {
      this.file_location = !this.file_location;
      this.file_owner = false;
      this.select_date = false;
      this.doctype = false;
    },
    select_filelocation(evt) {
      if (evt.target.nodeName === "LI") {
        this.filelocation = evt.target.getAttribute("data-text");
        this.file_location = false;
      }
    },
    showdate() {
      this.select_date = !this.select_date;
      this.file_owner = false;
      this.doctype = false;
      this.file_location = false;
    },
    showowner() {
      this.file_owner = !this.file_owner;
      this.select_date = false;
      this.doctype = false;
      this.file_location = false;
    },
    closemenudown(evt) {
      // console.log(evt.target.closet('.advance'))
      if (evt.target.className === "advance") {
        this.doctype = false;
        this.file_owner = false;
        this.select_date = false;
      }
    },
    customFormatter(date) {
      return moment(date).format("YYYY-D-MM");
    },
    showtype() {
      this.doctype = !this.doctype;
      this.select_date = false;
      this.file_owner = false;
    },
    makerequest() {
      this.advance = false;

      let term = "";

      if (
        this.filetype !== "" ||
        this.fileowner !== "" ||
        this.filename !== "" ||
        this.filedate !== "" ||
        this.filelocation !== ""
      ) {
        this.searchfile();
        let data = {
          token: cookies.getCookie("token"),
          type: this.filetype,
          owner: this.fileowner,
          name: this.filename,
          date: this.filedate,
          start_date: this.start_date,
          end_date: this.end_date,
          file_location: this.filelocation,
          method: "filter",
        };

        let that = this;

        this.$socket.emit("findfile", data, function (data) {
          if (data.data === true) {
            that.closesearch();
            that.SET_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
            that.SORT_DIRECTORY_CHILDREN();
            that.SET_PATH(data.dir_path);
          }

          if (data.data === false) {
            that.closesearch();
            that.logincall();
            that.$router.push('/login')
          }
        });
      }
    },
    openadvance() {
      this.listdown = false;
      this.advance = !this.advance;
    },
    resetsearch() {
      this.filetype = "Select file type";
      this.fileowner = "Owned by me";
      this.filedate = "Select date file was modified";
      this.filelocation = "My Space";
      this.start_date = "";
      this.end_date = "";
    },
    closeadvance() {
      this.listdown = false;
      this.advance = false;
    },
    compressfile() {
      if (this.$store.getters.FILE_ACTION > 1) {
        this.$parent.promptcompressrename();
        return;
      }

      let items = Object.values(this.$store.getters.GET_FILES_INDEX);
      this.$parent.compressfile(items[0], "group");
    },
    searchfile() {
      this.$parent.searchfile();
    },
    closesearch() {
      this.$parent.closesearchfile();
    },
    closelistdown(e) {
      let term = "";
      if (e.target.nodeName === "LI" || e.target.nodeName === "I") {
        this.listdown = false;
      }

      if (e.target.nodeName === "LI") {
        this.type_term = "type:" + e.target.innerText.trim();
        term = e.target.innerText.trim();
      }

      if (e.target.nodeName === "I") {
        this.type_term = "type:" + e.target.parentNode.innerText.trim();
        term = e.target.parentNode.innerText.trim();
      }

      if (term != "") {
        this.searchfile();
        let data = {
          token: cookies.getCookie("token"),
          term: term,
          method: "type",
        };

        let that = this;

        this.$socket.emit("findfile", data, function (data) {
          if (data.data === true) {
            that.closesearch();
            that.SET_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
            that.SORT_DIRECTORY_CHILDREN();
            that.SET_PATH(data.dir_path);
          }

          if (data.data === false) {
            that.closesearch();
            that.logincall();
          }
        });
      }
    },
    copyto() {
      this.$parent.group_copyto();
    },
    moveto() {
      this.$parent.group_moveto();
    },
    sharefile() {
      this.$parent.sharefile(null, true);
    },
    deletefile() {
      let index =
        this.$store.getters.GET_FILES_INDEX[
          this.$store.getters.GET_FILE_ACTION[0]
        ];
      let name = this.$store.getters.DIRECTORY_CHILDREN[index].dir;
      let id = this.$store.getters.DIRECTORY_CHILDREN[index].id;
      if (this.$store.getters.GET_CURRENT_DIRECTORY == "Trash") {
        this.$parent.trashdeleteprompt(index, id);
      } else {
        this.$parent.deletefile(index, id, "group");
      }
    },
    deleteall() {
      this.$parent.grouptrashdeleteprompt();
    },
    addtofavourite() {
      this.$parent.group_add_to_favourite();
    },
    addcomment() {
      let index =
        this.$store.getters.GET_FILES_INDEX[
          this.$store.getters.GET_FILE_ACTION[0]
        ];
      let name = this.$store.getters.DIRECTORY_CHILDREN[index].dir;
      let id = this.$store.getters.DIRECTORY_CHILDREN[index].id;
      this.$parent.add_comment(name, id);
    },
    renamefile() {
      let index =
        this.$store.getters.GET_FILES_INDEX[
          this.$store.getters.GET_FILE_ACTION[0]
        ];
      let name = this.$store.getters.DIRECTORY_CHILDREN[index].dir;
      let id = this.$store.getters.DIRECTORY_CHILDREN[index].id;
      this.$parent.renamefile(index, name, id, true);
    },
    restorefile() {
      let index =
        this.$store.getters.GET_FILES_INDEX[
          this.$store.getters.GET_FILE_ACTION[0]
        ];

      this.$parent.restorefile(index);
    },
    restore() {
      this.$parent.grouprestore();
    },
    deletefiles() {
      this.$parent.group_delete();
    },
    slideout() {
      this.UPDATE_SLIDEIN(true);
      this.UPDATE_SLIDEOUT(false);
      this.UPDATE_MENU(false);
      this.UPDATE_BODY_MENU(true);
    },
    showlistdown() {
      this.type_term = "";
      this.listdown = true;
      this.advance = false;
    },
    hidelistdown(e) {},
    show_chat() {
      this.TOGGLE_EMBED("chat");
    },
    show_note() {
      this.TOGGLE_EMBED("note");
    },
    show_notification() {
      this.TOGGLE_EMBED("notification");
    },
    sort_type_action(type) {
      this.SET_SORT_TYPE(type);
      this.SORT_DIRECTORY_CHILDREN();
    },
    sort_order_action(order) {
      this.SET_SORT_ORDER(order);
      this.SORT_DIRECTORY_CHILDREN();
    },
    view_type_action(type) {
      if (
        this.$store.getters.DIRECTORY_CHILDREN[
          this.$store.getters.GET_FILE_INDEX
        ] != undefined
      ) {
        this.$store.getters.DIRECTORY_CHILDREN[
          this.$store.getters.GET_FILE_INDEX
        ].show = false;
        this.SET_VIEW_TYPE(type);
      } else {
        this.SET_VIEW_TYPE(type);
      }
      this.$parent.set_view_type(type);
    },
    show_sort_order() {
      this.sort_order = !this.sort_order;
    },
    show_create_dropdown() {
      this.create_dropdown = !this.create_dropdown;
    },
    show_view_options() {
      this.view_options = !this.view_options;
    },
    hide() {
      this.create_dropdown = false;
      this.sort_order = false;
      this.view_options = false;
      this.listdown = false;
      this.settings_dropdown = false;
      this.notification_dropdown = false;
      this.advance = false;
      this.show_min = false;
      this.doctype = false;
      this.userdropdown = false;
      this.sub_dropdown = false;
    },
    create_doc(type) {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</>'
            );
            return;
          }
        }
      }

      if (this.$store.getters.GET_CURRENT_DIRECTORY == "Trash") {
        this.$parent.cant_create(this.$store.getters.GET_CURRENT_DIRECTORY);
      } else {
        this.$parent.create(type);
      }
    },
    trigger() {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }

      let up = document.querySelector("#file");
      up.click();
    },
    upload() {
      this.$parent.upload(this.$refs.file.files);
      this.$refs.file.value = "";
    },
    close_drop(e) {
      if (
        e.target.nodeName === "LI" ||
        e.target.nodeName === "I" ||
        e.target.nodeName === "IMG" ||
        e.target.nodeName === "svg" ||
        e.target.nodeName === "SPAN"
      ) {
        this.create_dropdown = false;
        this.sort_order = false;
        this.view_options = false;
      }
    },
    show_settings_dropdown() {
      if (this.settings_dropdown) {
        this.settings_dropdown = false;
      } else {
        this.settings_dropdown = true;
      }
    },
    show_notification_dropdown() {
      this.notification_dropdown = !this.notification_dropdown;
      let that = this;
      let ids = this.$store.getters.NOTIFICATION.filter((n) => {
        if (!n.is_checked.includes(localStorage.getItem("id"))) {
          return n.id;
        }
      });

      ids = ids.map((id) => {
        return id.id;
      });

      if (ids.length) {
        let data = {
          token: cookies.getCookie("token"),
          ids,
        };
        this.$socket.emit("update-check-notification", data, function (data) {
          if (data.data == true) {
            that.UPDATE_NOTIFICATION_COUNT(0);
          }
        });
      }
    },
  },
  mounted() {
    this.show_subdown();
    this.popupItem = this.$el;
  },
  directives: {
    onClickaway: onClickaway,
    ClickOutside,
  },
};
</script>
